import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'time12',
  standalone: true
})
export class Time12Pipe implements PipeTransform {

  transform(value: string): string {
    const date = new Date(`1970-01-01T${value}`);
    return date.toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  }


}
